module.exports = __webpack_public_path__ + "img/monitor-original.2b0806f0.png";